// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2_lvO","options":"AnswerScale_options__3Oj6o","selected":"AnswerScale_selected__1zF3q"};